export var AnalyticsTrackedElements;
(function (AnalyticsTrackedElements) {
    AnalyticsTrackedElements["LINK"] = "a";
    AnalyticsTrackedElements["BUTTON"] = "button";
    AnalyticsTrackedElements["INPUT_BUTTON"] = "input[type=\"button\"]";
    AnalyticsTrackedElements["INPUT_SUBMIT"] = "input[type=\"submit\"]";
})(AnalyticsTrackedElements || (AnalyticsTrackedElements = {}));
export var AnalyticsTrackedEvents;
(function (AnalyticsTrackedEvents) {
    AnalyticsTrackedEvents["CLICK"] = "click";
    AnalyticsTrackedEvents["CHANGE"] = "change";
})(AnalyticsTrackedEvents || (AnalyticsTrackedEvents = {}));
export var AnalyticsHTMLAttributes;
(function (AnalyticsHTMLAttributes) {
    AnalyticsHTMLAttributes["CLICKABLE"] = "data-metrics-clickable";
    AnalyticsHTMLAttributes["TYPE"] = "data-metrics-type";
    AnalyticsHTMLAttributes["TEXT"] = "data-metrics-link-text";
    AnalyticsHTMLAttributes["LOCATION"] = "data-metrics-location";
})(AnalyticsHTMLAttributes || (AnalyticsHTMLAttributes = {}));
//# sourceMappingURL=analytics.enums.js.map